import { Component, Injectable, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ZuperSdkService } from 'app/core/services/sdk_service/sdk.services';
import { kebabCase } from 'lodash';
import { ReplaySubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SnackBarService {
  public clearSelection: ReplaySubject<any> = new ReplaySubject<any>(1);
  public snackBarDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
  snacbarStatusCount: number = 0;
  constructor(private _snackBar: MatSnackBar){
    this.clearSelection.next(false);
    this.snackBarDataSubject.next({});
  }

  openSnackBar(snackbarStatus: any): void {
    if (this.snacbarStatusCount === 0){
      this._snackBar.openFromComponent(SnackBarComponent);
      this.snacbarStatusCount = snackbarStatus === 'open' ? this.snacbarStatusCount+1 : 0;
    }
  }

  closeSnackBar(performAction = false,action = ''): void{
    this.snacbarStatusCount = 0;
    this._snackBar.dismiss();
      const snackbaremit = {
        performAction: performAction,
        action: action
      };
    this.clearSelection.next(snackbaremit);
  }

}
@Component({
  selector: 'snackbar',
  templateUrl: 'snackbar.component.html',
  styleUrls: ['snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SnackBarComponent implements OnDestroy {
  snackBarSubscription: Subscription;

  sdkSnackBarButtonSubscription: Subscription;
  data: any = {};
  constructor(
    private snackBarService: SnackBarService, private utilityService: UtilityService,
    private _zuperSdkService: ZuperSdkService,
  ) {
    this.snackBarSubscription = this.snackBarService.snackBarDataSubject.subscribe((snackBarData: any) => {
      this.data = snackBarData;
      this.addExisitingButtonFromSDK();
    });
    this.sdkSnackBarButtonSubscription = this._zuperSdkService.snackBarEvent.subscribe((message: any) => {
      if (!message) {
        return;
      }
      const config = message.data?.config;
      switch (message.action) {
        case 'create':
          this.addNewButton(message.data, true);
          break;
        case 'hide':
          this.showOrHideButton(config.id, false);
          break;
        case 'show':
          this.showOrHideButton(config.id, true);
          break;
        case 'remove':
          this.removeButton(config.id);
      }
    });
  }

  emitSnackbarEvent(event: string, value?: any): void {
    switch (event) {
      case 'clearSelection':
        this.snackBarService.closeSnackBar(false, '');
        break;
      case 'bulkAction':
        this.snackBarService.closeSnackBar(true, value);
        break;
    }
  }

  getSnackBarContent(): string {
    let snackBarContent: string = this.data.module + '(s)';
    switch (this.data.module) {
      case 'AR/AGING':
        snackBarContent = this.utilityService.getLocaleValue('text.selected');
        break;
      case 'ESTIMATE':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.quotes','quote(s)');
        break;
      case 'JOB':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.jobs','job(s)');
        break;
      case 'PPM':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.ppm','ppm(s) in this page');
        break;
      case 'PRODUCT':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.products','Product(s)');
        break;
      case 'PAYMENTS':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.payments','Payment(s)');
        break;
      case 'SERVICE_CONTRACTS':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.contracts','Contract(s)');
        break;
      case 'SERVICE_CONTRACT':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.contracts','Contract(s)');
        break;
      case 'PROJECT':
        snackBarContent = this.utilityService.getLocaleValue('text.projects.bulk.action.suffix.message','Project(s)');
        break;
      case 'REQUEST':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.requests','Request(s)');
        break;
      case 'ORGANIZATION':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.organization','Organization(s)');
        break;
      case 'PROPERTY':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.property','Property(s)');
        break;
      case 'INVOICE':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.invoice','Invoice(s)');
        break;
      case 'ASSETS':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.asset','Asset(s)');
        break;
      case 'CUSTOMER':
        if(this.utilityService.companyPolicy?.enable_b2b){
          snackBarContent = this.utilityService.getLocaleValue('snackbar.content.customers', 'Contact(s)');
        }
        else{
          snackBarContent = this.utilityService.getLocaleValue('snackbar.content.customers','Customer(s)');
        }
        break;
      case 'REQUEST_SERVICE':
        snackBarContent = this.utilityService.getLocaleValue('snackbar.content.request_service','Service(s)');
        break;
    }
    return snackBarContent;
  }

  addExisitingButtonFromSDK(): void {
    const buttons: any[] = this._zuperSdkService.fetchCreatedButtons('BULK_ACTION');
    buttons.forEach((btnData: any) => {
      this.addNewButton(btnData, false);
    });
  }

  addNewButton(message: any, isNew = true): void{
    const config = message.params['ui.create'][0];
    const btnIndex = this.data.actionButton.findIndex(i => i.key === config.id);
    if (btnIndex >= 0) {
      return;
    }
    const buttonData = {
      displayName: kebabCase(config.title),
      displayKey: config.title,
      key: config.id,
      showIf: true,
    };
    this.data.actionButton.splice(config.position === 'left' ? 0 : this.data.actionButton.length, 0, buttonData);
  }

  showOrHideButton(id: string, canDisplay = true): void {
    const index = this.data.actionButton.findIndex(button => button.key === id);
    if (index >= 0) {
      this.data.actionButton[index].showIf = canDisplay;
    }
  }

  removeButton(id: string): void {
    const index = this.data.actionButton.findIndex(button => button.key === id);
    if (index >= 0) {
      this.data.actionButton.splice(index, 1);
    }
  }

  ngOnDestroy(): void {
    this.snackBarSubscription.unsubscribe();
    this.sdkSnackBarButtonSubscription.unsubscribe();
  }
}
